module.exports = __webpack_public_path__ + "static/media/400114_01.37c2f064.png";